import { useLoading } from "./LoadingContext";
import { useEffect } from "react";
import LoadingScreen from './LoadingComponent';

export const CustomLoading = () => {
  const { loading, step, subStep } = useLoading();
  useEffect(() => {
    if (loading) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }

    return () => {
      document.body.classList.remove('no-scroll');
    };

  }, [loading]);

  return <LoadingScreen step={step} subStep={subStep} visible={loading}></LoadingScreen>
};

